<template>
	<div class="model1">
		<div class="m1_info_box_title">
			{{ msg }}
		</div>
		<!-- 文章列表部分 -->
		<div class="m1_info_box">
			<ul
				class="m1_info_ul"
				style="margin-top:20px;padding-bottom: 10px;"
			>
				<div v-for="(item, index) in dataList" :key="index">
					<div class="boxContent_block_list_row">
						<div class="boxContent_block_list_rowIcon">
							<img
								src="../../../assets/hot/listtitle.png"
								alt=""
								@click="gotoDocDetail(item)"
							/>
						</div>
						<div
							class="boxContent_block_list_rowCt"
							:title="item.title"
							@click="gotoDocDetail(item)"
						>
							{{ item.title }}
						</div>
						<div class="boxContent_block_list_rowTime">
							{{ item.deliveddate.slice(0, 10) }}
						</div>
					</div>
					<div class="tenLines" v-if="index == 10"></div>
				</div>
				<el-empty
					v-if="dataList.length <= 0 && loading == false"
					description="暂无数据!"
				></el-empty>
				<el-empty
					v-if="loading == true"
					description="加载中!"
				></el-empty>
			</ul>
			<div class="pagination_box">
				<el-pagination
					v-if="dataList.length > 0"
					background
					@current-change="handleCurrentChange"
					:current-page="currentPage"
					:page-size="pagesize"
					layout="total, prev, pager, next, jumper"
					:total="total"
				>
				</el-pagination>
			</div>
		</div>
	</div>
</template>
<script>
import api from '@/../static/common/api/api.js';
import magic from '@/../static/common/magic.js';
import $ from 'jquery';
import echarts from 'echarts';

export default {
	// 普通二级页(默认)
	props: ['dataListSingle', 'msg', 'totals'],
	components: {},
	data() {
		return {
			dateRaneg: [], //日期
			startDate: '', //日历开始时间
			endDate: '', //日历结束时间
			dataType: '', //时间选项 0是 一周 1 是一个月 2 是一年 不限 ''
			currentPage: 1, //当前页
			total: 0, //总页数
			pagesize: 20, //每页条数
			dataList: [], //文章列表数据
			loading: false, //表格加载
		};
	},
	watch: {
		currentChoose(val) {
			this.currentPage = 1;
			// this.fetchDataList(val); //获取文章列表
		},
		dataListSingle(val) {
			this.fetchDataList(val);
		},
	},
	computed: {},
	created() {},
	mounted() {
		setTimeout(() => {
			$('.el-range-editor--small.el-input__inner').css(
				'border',
				'1px solid #F3F3F3'
			);
			$('.el-pagination__editor.el-input .el-input__inner').css(
				'border',
				'1px solid #E6E6E6!important'
			);
		}, 200);

		// this.fetchDataList(this.currentChoose);
	},
	methods: {
		//点击事件切换文章列表
		tabclickfn(num) {
			$('.m1_tab_btn').removeClass('m1_search_active');
			if (num == -1) {
				this.dataType = '';
				$('.m1_tab_btn')
					.eq(0)
					.addClass('m1_search_active');
			} else {
				this.dataType = num;
				$('.m1_tab_btn')
					.eq(Number(num) + 1)
					.addClass('m1_search_active');
			}

			this.startDate = '';
			this.endDate = '';
			this.dateRaneg = [];

			this.currentPage = 1;
			// this.fetchDataList(this.currentChoose);
		},
		gotoDocDetail(item) {
			//打开文章
			window.open(
				'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx?chnId=' +
					item.chnid +
					'&docid=' +
					item.docid +
					'&leafid=' +
					item.leafid
			);
			// this.$router.push({
			// 	path:
			// 		'http://d.drcnet.com.cn/eDRCnet.common.web/DocDetail.aspx',
			// 	query: {
			// 		chnId: item.chnId,
			// 		docid: item.docid,
			// 		leafid: item.leafid,
			// 	},
			// });
		},
		//获取数据列表
		fetchDataList(_uid) {
			this.loading = true;
			this.dataList = this.dataListSingle.data;
			this.total = this.dataListSingle.totlalCount;
			this.loading = false;
			// dateType：0是 一周 1 是一个月 2 是一年;"startDate":"2022-05-01","endDate":"2022-05-02"
			// let params = {
			// 	uid: _uid,
			// 	pagesize: this.pagesize,
			// 	curpage: this.currentPage,
			// 	dateType: this.dataType,
			// 	startDate: this.startDate,
			// 	endDate: this.endDate,
			// };

			// api.getarticleList(params).then((res) => {
			// 	//console.log(res, 'list');
			// 	this.dataList = res.data.rows;
			// 	this.total = res.data.total;
			// });
		},
		//翻页
		handleCurrentChange(val) {
			this.$bus.$emit('current', val);
			this.currentPage = val;
			// this.fetchDataList(this.currentChoose);
		},
	},
	filters: {
		subData1: function(value) {
			return value.substring(0, 7);
		},
		subData2: function(value) {
			return value.substring(8, 10);
		},
	},
};
</script>
<style scoped lang="less">
.model1 {
	width: 1440px;
	margin: 0 auto;
	height: 100%;
	overflow: hidden;
	// padding: 14px 30px;
	// background: #fff;
}

//文章列表部分
.m1_info_box {
	width: 100%;
	overflow: hidden;
	position: relative;
	background: #fff;
	margin-bottom: 20px;
}
.m1_info_box h5 {
	width: 100%;
	height: 70px;
	line-height: 70px;
	border-bottom: 1px solid #e7ede5;
	font-size: 16px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #222222;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-top: 30px;
}
.m1_info_box h5 img {
	height: 18px;
	display: inline-block;
	margin-right: 5px;
	vertical-align: middle;
}
// 搜索框部分
.m1_search_box {
	position: absolute;
	top: 50px;
	right: 0;
	height: 32px;
	line-height: 32px;
}
.m1_search_box span {
	width: 70px;
	height: 30px;
	background: #ffffff;
	border: 1px solid #e7ede5;
	display: inline-block;
	font-size: 12px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #222222;
	text-align: center;
	line-height: 30px;
	position: relative;
	margin-right: 8px;
	cursor: pointer;
}
.m1_search_active {
	background: #edf7ec !important;
	border: 1px solid #4eac41 !important;
}
.m1_search_box span img {
	display: none;
}
.m1_search_active img {
	display: block !important;
	position: absolute;
	bottom: 0;
	right: 0;
}
.el-range-editor--small .el-range-input {
	border: 1px solid #ccc !important;
}
.m1_info_ul {
	// width: 100%;
	overflow: hidden;
	padding: 0 40px 20px 40px;
}
.m1_info_ul li {
	width: 100%;
	height: 77px;
	border-bottom: 1px solid #e7ede5;
	padding: 30px 0;
	cursor: pointer;
}

.m1_info_li_l {
	width: 126px;
	height: 100%;
	text-align: center;
	float: left;
	border-right: 1px solid #f3f3f3;
}
.m1_info_li_l h6 {
	font-size: 22px;
	font-family: Arial;
	font-weight: 400;
	color: #1b1b1b;
	width: 100%;
	text-align: center;
}
.m1_info_li_l span {
	width: 100%;
	display: block;
	text-align: center;
	font-size: 14px;
	color: #999;
}
.m1_info_li_r {
	padding-left: 36px;
	float: left;
	width: 625px;
}
.m1_info_li_r h6 {
	font-size: 18px;
	font-family: Source Han Sans CN;
	font-weight: 500;
	color: #4d4d4d;
	overflow: hidden;
	white-space: nowrap;
	text-overflow: ellipsis;
	-o-text-overflow: ellipsis;
	margin-bottom: 6px;
}
.m1_info_li_r h6:hover {
	color: #4eac41;
}
.m1_info_li_r span {
	display: block;
	width: 100%;
	line-height: 24px;
	font-size: 14px;
	font-family: Source Han Sans CN;
	font-weight: 400;
	color: #808080;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2; /* 这里是超出几行省略 */
	overflow: hidden;
}
// 分页
.pagination_box {
	width: 100%;
	overflow: hidden;
	margin-bottom: 30px;
	margin-top: 30px;
	margin-right: 30px;
	text-align: right;
}
.boxContent_block_list_row {
	display: flex;
	// margin-left: 43px;
	align-items: center;
	width: 100%;

	img {
		width: 7px;
		height: 12px;
		margin-right: 12px;
	}
	font-size: 17px;
	font-family: Microsoft YaHei;
	font-weight: 400;
	color: #333333;
	max-height: 47px;
	line-height: 47px;
	.boxContent_block_list_rowIcon {
		cursor: pointer;
		border-bottom: 1px dashed #e1e1e1;
	}
	.boxContent_block_list_rowCt {
		cursor: pointer;
		width: 90%;
		max-width: 90%;
		padding-right: 20px;
		white-space: nowrap;
		overflow: hidden; //这个是设置隐藏的。还有其他的，例如scroll，是超出固定长度，底部显示滚动条的。
		text-overflow: ellipsis; //这个就是设置直接隐藏掉文字，还是显示...的。当前是显示省略号。直接省略是clip
		display: inline-block; //根据不同标签display值，有的不用加。
		border-bottom: 1px dashed #e1e1e1;
		&:hover {
			color: rgb(93, 93, 245);
		}
	}
	.boxContent_block_list_rowTime {
		color: #929292;
		min-width: 90px;
		float: right;
		border-bottom: 1px dashed #e1e1e1;
	}
}
.m1_info_box_title {
	background: url(../../../assets/hot/text_bg.png) no-repeat right bottom #fff;
	overflow: hidden;
	margin: 10px auto;
	font-size: 18px;
	font-weight: bold;
	color: #000;
	padding: 15px 0 15px 20px;
}
/deep/ .el-pagination {
	padding-right: 40px;
}
.tenLines {
	border-bottom: 1px dashed #999;
	margin: 40px 0;
	line-height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/view/hotcolumn/hotdetail/detail1Model2.vue